<template>
  <div class="container">
    <pcTabBarComponent tabBarKey="user" />
    <pcUserNavComponent tabBarKey="user">
      <div class="row-item">
        <div class="column-item">
          <div class="column-title-item">
            <div class="title">财富</div>
            <div v-if="userInfo.UserIsCz == 1" class="btn" @click="handleShowRecharge">充值</div>
          </div>
          <div class="detail-item">
            <div class="name">用户余额</div>
            <div class="value">¥{{ Math.round(userInfo.Balance * 10000) / 10000 }}</div>
          </div>
        </div>
        <div class="column-item">
          <div class="column-title-item">
            <div class="title">分站</div>
            <router-link class="btn" :to="{path: userInfo.FzLevel >= 50 ? '/website' : '/buildSite'}">{{ userInfo.FzLevel >= 50 ? '管理' : '开通' }}</router-link>
          </div>
          <div class="detail-item">
            <div class="name">我的店铺</div>
            <div class="value">{{ userInfo.FzLevel >= 50 ? websiteData.site_name : '暂未开通' }}</div>
          </div>
        </div>
      </div>
      <div class="column-item">
          <div class="column-title-item">
            <div class="title">最近订单</div>
          </div>
          <div v-if="finish && orderList.length == 0" class="empty-item" style="padding: 50px 0;">
            <div class="icon img-cover"><img src="../../assets/pc-images/empty-icon.png" /></div>
          </div>
          <div v-else class="order-list-item">
            <div class="order-item" v-for="(item, index) in orderList" :key="index">
              <div class="order-header-item">
                <div class="item"><span>订单号: {{ item.Id }}</span><img class="btn" @click.prevent="handleCopy(`${item.Id}`)" src="../../assets/pc-images/copy-blue-icon.png" /></div>
                <div class="item"><span>时间: {{ $TOOL.dateFormat(item.CreateAt * 1000, 'yyyy-MM-dd hh:mm') }}</span></div>
                <div class="item" v-if="item.BuyParams && item.BuyParams.length > 0"><span>{{ item.BuyParams[0].name }}: {{ item.BuyParams[0].value }}</span> <img class="btn" @click.prevent="handleCopy(`${item.BuyParams[0].value}`)" src="../../assets/pc-images/copy-blue-icon.png" /></div>
                <div class="flex-1"></div>
                <div class="status" :class="'status-' + ([-1,1,2].includes(item.OrderStatus) ? 'green' : item.OrderStatus == 4 ? 'blue' : 'gray')">
                  <img class="icon" src="../../assets/pc-images/status-icon.png" />
                  <img class="black-icon" src="../../assets/pc-images/status-black-icon.png" />
                  {{ orderStatusObj[item.OrderStatus] }}
                </div>
              </div>
              <div class="goods-info-item">
                <div class="img img-cover">
                  <img v-if="item.Img" :src="item.Img" />
                  <img v-else src="../../assets/images/no-image-icon.png" />
                </div>
                <div class="info-item">
                  <div class="name-info-item">
                    <div class="name-item">{{ item.GoodsName }} ¥ {{ Math.round(item.SellingPrice * 100000) / 100000 }}</div>
                    <div class="money-item">实付款 <span>¥ {{ Math.round(item.Amount * 100000) / 100000 }}</span></div>
                  </div>
                  <div class="detail-item">
                    <div class="count-item">
                      <span>开始 {{ item.StartNum }}</span>·
                      <span>当前 {{ item.CurrentNum }}</span>·
                      <span>完成 {{ item.CurrentNum - item.StartNum }}</span>
                    </div>
                    <div class="btn-list-item">
                      <router-link :to="{ path: '/content', query: {order_id: item.Id, pageType: 2, page: 'add'} }" class="btn"><img src="../../assets/pc-images/order-gd-icon.png" class="icon"/>工单售后</router-link>
                      <div class="btn"><img src="../../assets/pc-images/order-view-icon.png" class="icon"/>查看详情</div>
                      <router-link :to="{ path: '/goodsDetail', query: {id: item.GoodsId} }" class="btn"><img src="../../assets/pc-images/order-buy-icon.png" class="icon"/>再次下单</router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>
    </pcUserNavComponent>
    <rechargeComponent v-if="dialog.recharge" ref="rechargeDialog" @success="onSuccess" @close="dialog.recharge = false" />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import pcTabBarComponent from '@/components/pcTabBarComponent'
import pcUserNavComponent from '@/components/pcUserNavComponent'
import rechargeComponent from './RechargeComponent'

export default {
  name: "User",
  components: {
    pcTabBarComponent,
    pcUserNavComponent,
    rechargeComponent
  },
  data() {
    return {
      websiteData: {},
      finish: false,
      orderList: [],
      orderStatusObj: { '-1': '待付款', '1': '已付款', '2': '处理中', '3': '异常', '4': '已完成', '5': '退单中', '6': '已退单', '7': '已退款', '8': '待处理' },
      dialog: {
        recharge: false
      }
    }
  },
  computed: {
    ...mapState(['userInfo', 'websiteInfo'])
  },
  filters: {
    phoneFormat(text) {
      if (text) {
        return text.substr(0, 3) + '****' + text.substr(-4)
      }
      return ''
    }
  },
  mounted() {
    if (this.userInfo.FzLevel >= 50) {
      this.handleGetWebsiteInfo()
    }
    this.getOrderList()
  },
  methods: {
    ...mapActions(['GetUserInfo']),
    onSuccess() {
      this.GetUserInfo()
    },
    handleShowRecharge() {
      this.dialog.recharge = true
      this.$nextTick(() => {
        this.$refs.rechargeDialog.open()
      })
    },
    handleCopy(text) {
      this.$copyText(`${text}`).then(() => {
        this.$toast('复制成功')
      }).catch(() => {
        this.$toast('复制失败')
      })
    },
    async handleGetWebsiteInfo() {
      var res = await this.$API.substationsInfo.post()
      this.websiteData = res.info
    },
    async getOrderList() {
      const params = {
        PageCount: 6, 
        Page: 1
      }
      var res = await this.$API.orderList.post(params)
      const data = []
      for (let index = 0; index < res.info.length; index++) {
        const item = res.info[index]
        data.push({
          ...item,
          CanTui: item.CanTui.split(','),
          BuyParams: JSON.parse(item.BuyParams)
        })
      }
      this.orderList = [
        ...data
      ]
      this.finish = true
    },
  },
}

</script>

<style lang="less" scoped>
.row-item {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .column-item {
    width: 486px;
    height: 120px;
    .detail-item {
      height: 28px;
      padding: 8px 18px 0;
      display: flex;
      align-items: center;
      .name {
        color: #64748b;
        font-size: 12px;
      }
      .value {
        margin-left: 20px;
        flex: 1;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        font-size: 18px;
        font-weight: 500;
        color: #393942;
      }
    }
  }
}
.column-item {
  border-radius: 5px;
  background-color: #fff;
  margin-bottom: 20px;
  .column-title-item {
    padding: 18px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .title {
      position: relative;
      height: 20px;
      padding-left: 18px;
      line-height: 20px;
      font-size: 18px;
      font-weight: 500;
      color: #393942;
      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 3px;
        border-radius: 0 2px 2px 0;
        background-color: #5783fc;
      }
    }
    .btn {
      cursor: pointer;
      color: #2563eb;
      font-weight: 500;
      margin-right: 15px;
    }
  }
}
.order-list-item {
  padding: 0 20px;
  overflow: hidden;
  .order-item {
    border: 1px solid #e5e5e5;
    border-radius: 5px;
    padding: 14px;
    margin-bottom: 10px;
    .order-header-item {
      display: flex;
      align-items: center;
      height: 20px;
      line-height: 20px;
      .item {
        display: flex;
        align-items: center;
        font-size: 10px;
        color: #64748b;
        margin-right: 25px;
        span {
          max-width: 150px;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
        .btn {
          width: 10px;
          height: 10px;
          cursor: pointer;
        }
      }
      .status {
        padding: 0 6px;
        border-radius: 5px;
        height: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 10px;
        &.status-green {
          background-color: #52ad3c;
          color: #fff;
        }
        &.status-blue {
          background-color: #5783fc;
          color: #fff;
        }
        &.status-gray {
          background-color: #e5e5e5;
          color: #383838;
          .icon {
            display: none;
          }
          .black-icon {
            display: block;
          }
        }
        .icon {
          width: 12px;
          height: 12px;
          margin-right: 5px;
        }
        .black-icon {
          width: 12px;
          height: 12px;
          margin-right: 5px;
          display: none;
        }
      }
    }
    .goods-info-item {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .img {
        width: 55px;
        height: 55px;
        border-radius: 5px;
        overflow: hidden;
        margin-right: 13px;
      }
      .info-item {
        flex: 1;
        .name-info-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          line-height: 22px;
          color: #393942;
          font-weight: 500;
          .name-item {
            flex: 1;
            margin-right: 10px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .money-item {
            span {
              color: #d43030;
              font-size: 18px;
            }
          }
        }
        .detail-item {
          margin-top: 6px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .count-item {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 200px;
            height: 20px;
            border-radius: 2px;
            background-color: #f6ffed;
            font-size: 10px;
            color: #52ad3c;
          }
          .btn-list-item {
            display: flex;
            align-items: center;
            .btn {
              display: flex;
              align-items: center;
              font-size: 10px;
              color: #5783fc;
              margin-left: 20px;
              cursor: pointer;
              .icon {
                margin-right: 5px;
                width: 10px;
                height: 10px;
              }
            }
          }
        }
      }
    }
  }
}
</style>